import { render } from "./avda_landing_page.vue?vue&type=template&id=33c3542d&scoped=true"
import script from "./avda_landing_page.vue?vue&type=script&lang=js"
export * from "./avda_landing_page.vue?vue&type=script&lang=js"

import "./avda_landing_page.vue?vue&type=style&index=0&id=33c3542d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c3542d"]])

export default __exports__